export default __webpack_public_path__ + "assets/community-one-four.e103ad89146b12857801a13bfbfbf847.png";